import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'

// features
import { css as catharsisExtensions } from '@wix/thunderbolt-catharsis-extensions'
import { css as catharsisIoc } from '@wix/thunderbolt-catharsis-ioc'
import type { ModuleLoaderFactory } from '../types'

const features = [catharsisExtensions, catharsisIoc]

export const getModuleLoader: ModuleLoaderFactory = (catharsisConstants) => {
	const moduleLoader: ContainerModuleLoader = (bind) => {
		features.forEach((loader) => loader(bind, catharsisConstants))
	}

	return moduleLoader
}
